<template>
  <div class="home-wrapper">
    <PaginaTitulo
      sticky
      :class="['home-titulo']"
      titulo="NCMS SELECIONADAS"
      subTitulo="Gerencie suas NCMs selecionadas"
    >
      <CounterNcm
        slot="primeiroSlot"
        :contadorAtual="loadingListaNcmsSelecionadas ? null : getContador"
        :contadorTotal="getAssinatura.qtde_pesquisa_ncm"
        tituloTooltipCheio="Limite de NCMs atingido."
        tituloTooltip=" "
      />
      <LineButtons
        :blCriarCenario="blCriarCenario"
        :blShowCriarCenario="blShowCriarCenario"
        :carregaCenario="carregaCenario"
        :arNcmSelecionados="getArNcmSelecionados"
        :loadingListaNcmsSelecionadas="loadingListaNcmsSelecionadas"
      />
    </PaginaTitulo>
    <div class="home-container">
      <BannerUpgrade
        v-if="getExibeBannerUpgrade && getAssinatura.id < 4 && !getUsuarioPro"
        :toggleBanner="setToggleBannerUpgrade"
      />
      <div class="home-tabela-container">
        <div class="input-container-home">
          <BotaoBusca :botoesBusca="botoesBusca" :tipo="tipo" :trocaTipo="trocaTipo" />
          <CenarioInput
            class="home-input"
            tipo="home"
            :tipoBusca="tipo"
            :minLengthDropdown="1"
            :maxLengthDropdown="20"
            :loadChange="carregandoNcm || carregandoGtin"
            :placeholder="placeholder"
            :noOptions="mensagemGtin && tipo == 'GTIN' ? mensagemGtin : 'Sem opções de NCM'"
            :model="termo"
            :options="ncmOptions"
            @update:model="update => (termo = update)"
            @selected="update => selecionaNcm(update.label)"
            :disabled="loadingListaNcmsSelecionadas"
            :mostraBotaoResultados="mostraBotaoResultados"
            :exibeTabelaBuscaNcmClick="exibeTabelaBuscaNcmClick"
          />
          <BotaoBannerUpgrade
            :exibeBotaoUpgrade="exibeBotaoUpgrade"
            :setToggleBannerUpgrade="setToggleBannerUpgrade"
          />
        </div>
        <ModalBuscaNcm
          :conteudoTabelaNcm="conteudoTabelaNcm"
          :selecionaNcm="selecionaNcm"
          :termoPesquisado="termoPesquisado"
          :carregandoTabelaNcm="carregandoTabelaNcm"
          :exibeTabelaBuscaNcm="exibeTabelaBuscaNcm"
        />
        <ModalLimparNcm :limparSelecionados="limparSelecionados" />
        <TabelaSuspensa
          class="home-tabela-suspensa"
          v-if="!!tabelaSuspensa.length && exibeTabelaSuspensa && !loadingListaNcmsSelecionadas"
          :conteudo="tabelaSuspensa"
          :fechaTabelaSuspensa="fechaTabelaSuspensa"
          :setLoading="setLoading"
          :mensagemSuspensa="mensagemSuspensa"
          :selecionaNcm="selecionaNcm"
        />
        <LoadingPadraoContainer
          v-if="loadingListaNcmsSelecionadas"
          :fraseLoading="['Carregando lista de NCMs', 'Aguarde um momento']"
          delay="5000"
          classe="azul"
        />
        <TabelaHome
          v-else-if="getArNcmSelecionados && getArNcmSelecionados.length > 0"
          :deletaItem="deletaItem"
          :conteudo="conteudo"
          :selecionaNcm="selecionaNcm"
        />
        <MensagemSemResultados v-else :mensagem="'Nenhuma NCM selecionada.'" />
      </div>
    </div>
  </div>
</template>

<script>
import CounterNcm from "@/modules/Pesquisa/components/Head/CounterNcm.vue";
import ModalAtualizacao from "@/components/ModalAtualizacao/ModalAtualizacao.vue";
import ModalLimparNcm from "@/components/ModalHome/ModalLimparNcm.vue";
import PaginaTitulo from "@/components/PaginaTitulo/PaginaTitulo.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";
import LineButtons from "@/modules/Pesquisa/components/Head/LineButtons.vue";
import TabelaHome from "./TabelaHome.vue";
import ModalBuscaNcm from "./ModalBuscaNcm.vue";
import TabelaBuscaNcm from "./TabelaBuscaNcm.vue";
import TabelaSuspensa from "./TabelaSuspensa.vue";
import BotaoBusca from "./BotaoBusca.vue";
import BotaoBannerUpgrade from "./BotaoBannerUpgrade.vue";
import CenarioInput from "@/components/CenarioInput/CenarioInput.vue";
import MensagemSemResultados from "@/components/MensagemSemResultados/MensagemSemResultados.vue";
import BannerUpgrade from "@/components/BannerUpgrade/BannerUpgrade.vue";

import pesquisaNcmMixin from "@/mixins/pesquisaNcmMixin";
import { mapGetters, mapActions } from "vuex";
import Api from "@/services/api";
import axios from "axios";

export default {
  name: "Home",
  components: {
    CounterNcm,
    ModalAtualizacao,
    ModalLimparNcm,
    PaginaTitulo,
    LoadingPadraoContainer,
    LineButtons,
    TabelaHome,
    ModalBuscaNcm,
    TabelaBuscaNcm,
    TabelaSuspensa,
    BotaoBusca,
    BotaoBannerUpgrade,
    CenarioInput,
    MensagemSemResultados,
    BannerUpgrade
  },
  mixins: [pesquisaNcmMixin],
  inject: ["pushAlert"],
  data() {
    return {
      termo: "",
      termoPesquisado: "",
      ncmSelecionada: "",
      tipo: "NCM",
      mensagemGtin: "",
      mensagemSuspensa: "",
      botoesBusca: ["NCM", "NBM", "GTIN"],
      conteudo: [],
      ncmOptions: [],
      tabelaSuspensa: [],
      exibeTabelaBuscaNcm: false,
      mostraBotaoResultados: false,
      conteudoTabelaNcm: [],
      carregandoNcm: false,
      carregandoTabelaNcm: false,
      carregandoGtin: false,
      blShowCriarCenario: true,
      blCriarCenario: true,
      loadingListaNcmsSelecionadas: false,
      exibeTabelaSuspensa: false,
      cancelTokenSource: null
    };
  },
  async created() {
    await this.carregaListaNcm();
    this.conteudo = this.getArNcmSelecionados.map(p => ({ ...p }));
  },
  watch: {
    getArNcmSelecionados: {
      deep: true,
      handler() {
        this.conteudo = this.getArNcmSelecionados.map(p => ({ ...p }));
      }
    },
    async termo() {
      if (this.termo.length != 0) {
        this.exibeTabelaBuscaNcm = false;
        this.exibeTabelaSuspensa = false;
      }
      if (this.tipo != "GTIN") {
        if (this.termo.length >= 2) {
          this.ncmOptions = await this.buscaNcm(this.termo);
        }
      } else if (this.termo.length >= 8) {
        this.mensagemGtin = "";
        let responseGtin = await this.buscaNcmGtin();
        if (responseGtin.NCM) {
          this.ncmOptions = await this.buscaNcm(responseGtin.NCM);
        } else if (responseGtin.ErrorMessage || responseGtin.XMotivo) {
          this.mensagemGtin = responseGtin.ErrorMessage
            ? responseGtin.ErrorMessage
            : responseGtin.XMotivo.replace("Rejeicao: ", "")
                .replaceAll(" nao ", " não ")
                .replaceAll(" digito", " dígito")
                .replaceAll(" invalido", " inválido")
                .replaceAll(" invalida", " inválida")
                .replaceAll(" situacao", " situação")
                .replaceAll(" publicacao", " publicação")
                .replaceAll(" informacoes", " informações");
          this.ncmOptions = [];
        } else {
          this.ncmOptions = [];
        }
      }
    }
  },
  computed: {
    ...mapGetters("listaNcm", ["getContador", "getMensagemNotificacao", "getArNcmSelecionados"]),
    ...mapGetters("login", ["getUser", "getAssinatura", "getExibeBannerUpgrade"]),
    ...mapGetters("auth", ["getUsuarioPro"]),
    placeholder() {
      return this.tipo == "GTIN"
        ? "Informe o GTIN do produto."
        : `Informe a descrição ou ${this.tipo} do produto.`;
    },
    exibeBotaoUpgrade() {
      return !this.getExibeBannerUpgrade && this.getAssinatura.id < 4 && !this.getUsuarioPro;
    }
  },
  methods: {
    ...mapActions("login", ["setToggleBannerUpgrade"]),
    ...mapActions("listaNcm", [
      "fetchArNcmSelecionados",
      "deleteNcm",
      "salvarNcm",
      "limparListaNcm"
    ]),
    ...mapActions("pesquisaNcm", [
      "fetchPesquisaMtrz",
      "fetchPesquisaMtrzCancel",
      "fetchNcmVigente",
      "resetPesquisa",
      "setOrdenamento",
      "setNavegaResultados"
    ]),
    trocaTipo(tipo) {
      this.tipo = tipo;
    },
    async buscaNcm(termo) {
      await new Api().cancel(500);
      this.carregandoNcm = true;
      this.mostraBotaoResultados = false;
      try {
        let response = await this.pesquisaNcmMatriz({
          valorPesquisa: termo,
          referencia: this.tipo == "NBM" ? "NBM" : "NCM",
          autoComplete: "S",
          limite: 10,
          page: 1,
          ordenacao: "ASC"
        });
        await response.data.forEach(e => {
          e.descricao = e.descricao.startsWith("-- ")
            ? e.descricao.slice(3)
            : e.descricao.startsWith("- ") || e.descricao.startsWith("--")
            ? e.descricao.slice(2)
            : e.descricao.startsWith("-")
            ? e.descricao.slice(1)
            : e.descricao;
          this.$set(
            e,
            "label",
            `${e.ncm} - ${e.ex && e.ex != 0 ? `Ex: ${e.ex} - ` : ""}${e.descricao}`
          );
        });
        this.carregandoNcm = false;
        this.mostraBotaoResultados = response.last_page == 1 ? false : true;
        return response.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    async buscaTodasNcm(termo) {
      await new Api().cancel(500);
      this.carregandoNcm = true;
      try {
        let response = await this.pesquisaNcmMatriz({
          valorPesquisa: termo,
          referencia: this.tipo == "NBM" ? "NBM" : "NCM",
          autoComplete: "S",
          limite: 5000,
          page: 1,
          ordenacao: "RELEVANCIA"
        });
        await response.data.forEach(e => {
          e.descricao = e.descricao.startsWith("-- ")
            ? e.descricao.slice(3)
            : e.descricao.startsWith("- ") || e.descricao.startsWith("--")
            ? e.descricao.slice(2)
            : e.descricao.startsWith("-")
            ? e.descricao.slice(1)
            : e.descricao;
        });
        this.carregandoNcm = false;
        return response.data;
      } catch (error) {
        return [];
      }
    },
    async carregaListaNcm() {
      this.loadingListaNcmsSelecionadas = true;
      await this.fetchArNcmSelecionados();
      this.loadingListaNcmsSelecionadas = false;
    },
    async deletaItem(item) {
      this.loadingListaNcmsSelecionadas = true;
      await this.deleteNcm(item.id);
      this.loadingListaNcmsSelecionadas = false;
    },
    async limparSelecionados() {
      this.loadingListaNcmsSelecionadas = true;
      await this.limparListaNcm();
      this.loadingListaNcmsSelecionadas = false;
    },
    async carregaCenario() {
      this.$router.push("/cenario");
    },
    async selecionaNcm(item, home = true) {
      this.exibeTabelaBuscaNcm = false;
      this.termo = "";
      if (this.getContador >= this.getAssinatura.qtde_pesquisa_ncm) {
        this.pushAlert("Limite de NCMs atingido", "danger");
        return;
      }
      this.loadingListaNcmsSelecionadas = true;
      let produto = home ? this.ncmOptions.find(f => f.label == item) : item;
      produto.id_usuario = this.getUser.id_usuario;
      if (produto.vigente == 0 || (produto.alterado == 1 && home)) {
        this.tabelaSuspensa = await this.pesquisaFilhos(produto);
        this.mensagemSuspensa = {
          titulo: `A NCM: <b>${produto.ncm}</b> ${
            produto.vigente == 0 ? "não se encontra mais vigente" : "foi alterada"
          }, selecione uma NCM vinculada abaixo:`,
          tipo: `${produto.vigente == 0 ? "nao-vigente" : "alterado"}`
        };
        this.exibeTabelaSuspensa = true;
      } else if (produto.exTipi && !!produto.exTipi.length) {
        this.tabelaSuspensa = produto.exTipi;
        this.mensagemSuspensa = {
          titulo: `A NCM: <b>${produto.ncm}</b> possui EX, selecione uma NCM vinculada abaixo:`,
          tipo: "ex"
        };

        this.exibeTabelaSuspensa = true;
      } else {
        let existe = this.getArNcmSelecionados.find(
          f => f.ncm == produto.ncm && f.ex == produto.ex
        );
        if (existe) {
          this.pushAlert("Esta NCM já está na sua lista.", "info");
        } else {
          await this.salvarNcm(produto);
        }
      }
      this.loadingListaNcmsSelecionadas = false;
    },
    async pesquisaFilhos(produto) {
      let response = await this.fetchPesquisaMtrz({
        valorPesquisa: produto.ncm,
        ex: produto.ex,
        vinculo: produto.idNcm,
        referencia: this.tipo == "NBM" ? "NBM" : "NCM",
        autoComplete: "N",
        limite: 10,
        page: 1,
        ordenacao: "ASC",
        buscaFilhos: true
      });
      // return response.data
      await response.data.forEach(e => {
        e.descricao = e.descricao.startsWith("-- ")
          ? e.descricao.slice(3)
          : e.descricao.startsWith("- ") || e.descricao.startsWith("--")
          ? e.descricao.slice(2)
          : e.descricao.startsWith("-")
          ? e.descricao.slice(1)
          : e.descricao;
      });
      return response.data.filter(f => !!f.vigente);
    },
    fechaTabelaSuspensa() {
      this.exibeTabelaSuspensa = false;
    },
    setLoading(bool) {
      this.loadingListaNcmsSelecionadas = bool;
    },
    async buscaNcmGtin() {
      this.carregandoGtin = true;
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel("cancelada");
      }

      if (this.termo.length > 0) {
        this.cancelTokenSource = axios.CancelToken.source();

        try {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; bG9naW4=`);
          let token = '';

          if (parts.length === 2) {
            token = parts.pop().split(';').shift().trim();
            token = token.replace(/%3D/g, "=");
          }

          let loginResponse = await new Api().post("Produto/login", {
            cookie: token
          });
          
          let tokenResponse = await new Api().get("Produto/gtin");
          let tokenData = tokenResponse.token;

          const axiosInstance = axios.create({
            baseURL: 'https://api.econeteditora.com.br',
            headers: {
                'accept': 'application/json, text/plain, */*',
                'accept-language': 'pt-BR,pt;q=0.9',
                'g-recaptcha-response': tokenData,
                'origin': 'https://app.econeteditora.com.br',
                'priority': 'u=1, i',
                'referer': 'https://app.econeteditora.com.br/',
                'sec-ch-ua': '"Not/A)Brand";v="8", "Chromium";v="126", "Google Chrome";v="126"',
                'sec-ch-ua-mobile': '?0',
                'sec-ch-ua-platform': '"Windows"',
                'sec-fetch-dest': 'empty',
                'sec-fetch-mode': 'cors',
                'sec-fetch-site': 'same-site',
                'user-agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/126.0.0.0 Safari/537.36'
            },
            maxBodyLength: Infinity,
            cancelToken: this.cancelTokenSource.token
          });
          delete axiosInstance.defaults.headers.common['Authorization'];
          axiosInstance.defaults.headers.common['Authorization'] = loginResponse;

          let response = await axiosInstance.get(`/api/gtin/Consultar/${this.termo}`);
          this.carregandoGtin = false;
          return response.data;
        } catch (error) {
          this.carregandoGtin = false;
          return { ErrorMessage: "Erro ao buscar GTIN" };
        }
      }
    },
    async exibeTabelaBuscaNcmClick() {
      this.$root.$emit("bv::show::modal", "ModalBuscaNcm");
      this.carregandoTabelaNcm = true;
      this.termoPesquisado = this.termo;
      this.exibeTabelaBuscaNcm = true;
      this.conteudoTabelaNcm = await this.buscaTodasNcm(this.termo);
      this.carregandoTabelaNcm = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 500px;
}
.home-container {
  max-width: 1155px;
  width: 100%;
}
.home-tabela-container {
  padding: 0 15px;
  margin-top: 15px;
}
.input-container-home {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.home-input {
  margin-left: 5px;
  background: var(--branco);
}
.home-tabela-suspensa {
  margin-bottom: 15px;
}
.tabela-busca-ncm {
  margin-bottom: 10px;
}
</style>
